/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as AdminInicioRouteImport } from './routes/admin/inicio'
import { Route as PublicQuienesSomosRouteImport } from './routes/_public/quienes-somos'
import { Route as PublicNoticiasRouteImport } from './routes/_public/noticias'
import { Route as PublicFaqRouteImport } from './routes/_public/faq'
import { Route as PublicEstadisticasRouteImport } from './routes/_public/estadisticas'
import { Route as PublicEnsuassRouteImport } from './routes/_public/ensuass'
import { Route as AdminSeguridadUsuariosRouteImport } from './routes/admin/seguridad/usuarios'
import { Route as AdminSeguridadSmtpRouteImport } from './routes/admin/seguridad/smtp'
import { Route as AdminSeguridadSesionesRouteImport } from './routes/admin/seguridad/sesiones'
import { Route as AdminSeguridadRolesRouteImport } from './routes/admin/seguridad/roles'
import { Route as AdminSeguridadPermisosRouteImport } from './routes/admin/seguridad/permisos'
import { Route as AdminSeguridadOrganizacionesRouteImport } from './routes/admin/seguridad/organizaciones'
import { Route as AdminSeguridadAplicacionesRouteImport } from './routes/admin/seguridad/aplicaciones'
import { Route as AdminRecetSeccionesRouteImport } from './routes/admin/recet/secciones'
import { Route as AdminRecetReferenciasRouteImport } from './routes/admin/recet/referencias'
import { Route as AdminRecetImportacionesRouteImport } from './routes/admin/recet/importaciones'
import { Route as AdminRecetCostoEfectividadRouteImport } from './routes/admin/recet/costo-efectividad'
import { Route as AdminOnboardingPasosRouteImport } from './routes/admin/onboarding/pasos'
import { Route as AdminNotificacionesPlantillasRouteImport } from './routes/admin/notificaciones/plantillas'
import { Route as AdminNotificacionesEnviosRouteImport } from './routes/admin/notificaciones/envios'
import { Route as AdminEnsuassSolicitudesRouteImport } from './routes/admin/ensuass/solicitudes'
import { Route as AdminConfiguracionParametrosRouteImport } from './routes/admin/configuracion/parametros'
import { Route as AdminRecetTecnologiasIndexRouteImport } from './routes/admin/recet/tecnologias/index'
import { Route as AdminRecetFichasIndexRouteImport } from './routes/admin/recet/fichas/index'
import { Route as AdminOnboardingPasosIndexRouteImport } from './routes/admin/onboarding/pasos/index'
import { Route as AdminRecetTecnologiasIdRouteImport } from './routes/admin/recet/tecnologias/$id'
import { Route as AdminRecetFichasIdRouteImport } from './routes/admin/recet/fichas/$id'
import { Route as AdminOnboardingPasosIdRouteImport } from './routes/admin/onboarding/pasos/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const AdminInicioRoute = AdminInicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => AdminRoute,
} as any).lazy(() => import('./routes/admin/inicio.lazy').then((d) => d.Route))
const PublicQuienesSomosRoute = PublicQuienesSomosRouteImport.update({
  id: '/quienes-somos',
  path: '/quienes-somos',
  getParentRoute: () => PublicRoute,
} as any)
const PublicNoticiasRoute = PublicNoticiasRouteImport.update({
  id: '/noticias',
  path: '/noticias',
  getParentRoute: () => PublicRoute,
} as any)
const PublicFaqRoute = PublicFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => PublicRoute,
} as any)
const PublicEstadisticasRoute = PublicEstadisticasRouteImport.update({
  id: '/estadisticas',
  path: '/estadisticas',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public/estadisticas.lazy').then((d) => d.Route),
)
const PublicEnsuassRoute = PublicEnsuassRouteImport.update({
  id: '/ensuass',
  path: '/ensuass',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public/ensuass.lazy').then((d) => d.Route),
)
const AdminSeguridadUsuariosRoute = AdminSeguridadUsuariosRouteImport.update({
  id: '/seguridad/usuarios',
  path: '/seguridad/usuarios',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/seguridad/usuarios.lazy').then((d) => d.Route),
)
const AdminSeguridadSmtpRoute = AdminSeguridadSmtpRouteImport.update({
  id: '/seguridad/smtp',
  path: '/seguridad/smtp',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/seguridad/smtp.lazy').then((d) => d.Route),
)
const AdminSeguridadSesionesRoute = AdminSeguridadSesionesRouteImport.update({
  id: '/seguridad/sesiones',
  path: '/seguridad/sesiones',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/seguridad/sesiones.lazy').then((d) => d.Route),
)
const AdminSeguridadRolesRoute = AdminSeguridadRolesRouteImport.update({
  id: '/seguridad/roles',
  path: '/seguridad/roles',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/seguridad/roles.lazy').then((d) => d.Route),
)
const AdminSeguridadPermisosRoute = AdminSeguridadPermisosRouteImport.update({
  id: '/seguridad/permisos',
  path: '/seguridad/permisos',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/seguridad/permisos.lazy').then((d) => d.Route),
)
const AdminSeguridadOrganizacionesRoute =
  AdminSeguridadOrganizacionesRouteImport.update({
    id: '/seguridad/organizaciones',
    path: '/seguridad/organizaciones',
    getParentRoute: () => AdminRoute,
  } as any).lazy(() =>
    import('./routes/admin/seguridad/organizaciones.lazy').then((d) => d.Route),
  )
const AdminSeguridadAplicacionesRoute =
  AdminSeguridadAplicacionesRouteImport.update({
    id: '/seguridad/aplicaciones',
    path: '/seguridad/aplicaciones',
    getParentRoute: () => AdminRoute,
  } as any).lazy(() =>
    import('./routes/admin/seguridad/aplicaciones.lazy').then((d) => d.Route),
  )
const AdminRecetSeccionesRoute = AdminRecetSeccionesRouteImport.update({
  id: '/recet/secciones',
  path: '/recet/secciones',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/recet/secciones.lazy').then((d) => d.Route),
)
const AdminRecetReferenciasRoute = AdminRecetReferenciasRouteImport.update({
  id: '/recet/referencias',
  path: '/recet/referencias',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/recet/referencias.lazy').then((d) => d.Route),
)
const AdminRecetImportacionesRoute = AdminRecetImportacionesRouteImport.update({
  id: '/recet/importaciones',
  path: '/recet/importaciones',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/recet/importaciones.lazy').then((d) => d.Route),
)
const AdminRecetCostoEfectividadRoute =
  AdminRecetCostoEfectividadRouteImport.update({
    id: '/recet/costo-efectividad',
    path: '/recet/costo-efectividad',
    getParentRoute: () => AdminRoute,
  } as any).lazy(() =>
    import('./routes/admin/recet/costo-efectividad.lazy').then((d) => d.Route),
  )
const AdminOnboardingPasosRoute = AdminOnboardingPasosRouteImport.update({
  id: '/onboarding/pasos',
  path: '/onboarding/pasos',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNotificacionesPlantillasRoute =
  AdminNotificacionesPlantillasRouteImport.update({
    id: '/notificaciones/plantillas',
    path: '/notificaciones/plantillas',
    getParentRoute: () => AdminRoute,
  } as any).lazy(() =>
    import('./routes/admin/notificaciones/plantillas.lazy').then(
      (d) => d.Route,
    ),
  )
const AdminNotificacionesEnviosRoute =
  AdminNotificacionesEnviosRouteImport.update({
    id: '/notificaciones/envios',
    path: '/notificaciones/envios',
    getParentRoute: () => AdminRoute,
  } as any).lazy(() =>
    import('./routes/admin/notificaciones/envios.lazy').then((d) => d.Route),
  )
const AdminEnsuassSolicitudesRoute = AdminEnsuassSolicitudesRouteImport.update({
  id: '/ensuass/solicitudes',
  path: '/ensuass/solicitudes',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/ensuass/solicitudes.lazy').then((d) => d.Route),
)
const AdminConfiguracionParametrosRoute =
  AdminConfiguracionParametrosRouteImport.update({
    id: '/configuracion/parametros',
    path: '/configuracion/parametros',
    getParentRoute: () => AdminRoute,
  } as any).lazy(() =>
    import('./routes/admin/configuracion/parametros.lazy').then((d) => d.Route),
  )
const AdminRecetTecnologiasIndexRoute =
  AdminRecetTecnologiasIndexRouteImport.update({
    id: '/recet/tecnologias/',
    path: '/recet/tecnologias/',
    getParentRoute: () => AdminRoute,
  } as any).lazy(() =>
    import('./routes/admin/recet/tecnologias/index.lazy').then((d) => d.Route),
  )
const AdminRecetFichasIndexRoute = AdminRecetFichasIndexRouteImport.update({
  id: '/recet/fichas/',
  path: '/recet/fichas/',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/recet/fichas/index.lazy').then((d) => d.Route),
)
const AdminOnboardingPasosIndexRoute =
  AdminOnboardingPasosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminOnboardingPasosRoute,
  } as any).lazy(() =>
    import('./routes/admin/onboarding/pasos/index.lazy').then((d) => d.Route),
  )
const AdminRecetTecnologiasIdRoute = AdminRecetTecnologiasIdRouteImport.update({
  id: '/recet/tecnologias/$id',
  path: '/recet/tecnologias/$id',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/recet/tecnologias/$id.lazy').then((d) => d.Route),
)
const AdminRecetFichasIdRoute = AdminRecetFichasIdRouteImport.update({
  id: '/recet/fichas/$id',
  path: '/recet/fichas/$id',
  getParentRoute: () => AdminRoute,
} as any).lazy(() =>
  import('./routes/admin/recet/fichas/$id.lazy').then((d) => d.Route),
)
const AdminOnboardingPasosIdRoute = AdminOnboardingPasosIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminOnboardingPasosRoute,
} as any).lazy(() =>
  import('./routes/admin/onboarding/pasos/$id.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/ensuass': typeof PublicEnsuassRoute
  '/estadisticas': typeof PublicEstadisticasRoute
  '/faq': typeof PublicFaqRoute
  '/noticias': typeof PublicNoticiasRoute
  '/quienes-somos': typeof PublicQuienesSomosRoute
  '/admin/inicio': typeof AdminInicioRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/configuracion/parametros': typeof AdminConfiguracionParametrosRoute
  '/admin/ensuass/solicitudes': typeof AdminEnsuassSolicitudesRoute
  '/admin/notificaciones/envios': typeof AdminNotificacionesEnviosRoute
  '/admin/notificaciones/plantillas': typeof AdminNotificacionesPlantillasRoute
  '/admin/onboarding/pasos': typeof AdminOnboardingPasosRouteWithChildren
  '/admin/recet/costo-efectividad': typeof AdminRecetCostoEfectividadRoute
  '/admin/recet/importaciones': typeof AdminRecetImportacionesRoute
  '/admin/recet/referencias': typeof AdminRecetReferenciasRoute
  '/admin/recet/secciones': typeof AdminRecetSeccionesRoute
  '/admin/seguridad/aplicaciones': typeof AdminSeguridadAplicacionesRoute
  '/admin/seguridad/organizaciones': typeof AdminSeguridadOrganizacionesRoute
  '/admin/seguridad/permisos': typeof AdminSeguridadPermisosRoute
  '/admin/seguridad/roles': typeof AdminSeguridadRolesRoute
  '/admin/seguridad/sesiones': typeof AdminSeguridadSesionesRoute
  '/admin/seguridad/smtp': typeof AdminSeguridadSmtpRoute
  '/admin/seguridad/usuarios': typeof AdminSeguridadUsuariosRoute
  '/admin/onboarding/pasos/$id': typeof AdminOnboardingPasosIdRoute
  '/admin/recet/fichas/$id': typeof AdminRecetFichasIdRoute
  '/admin/recet/tecnologias/$id': typeof AdminRecetTecnologiasIdRoute
  '/admin/onboarding/pasos/': typeof AdminOnboardingPasosIndexRoute
  '/admin/recet/fichas/': typeof AdminRecetFichasIndexRoute
  '/admin/recet/tecnologias/': typeof AdminRecetTecnologiasIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/ensuass': typeof PublicEnsuassRoute
  '/estadisticas': typeof PublicEstadisticasRoute
  '/faq': typeof PublicFaqRoute
  '/noticias': typeof PublicNoticiasRoute
  '/quienes-somos': typeof PublicQuienesSomosRoute
  '/admin/inicio': typeof AdminInicioRoute
  '/': typeof PublicIndexRoute
  '/admin': typeof AdminIndexRoute
  '/admin/configuracion/parametros': typeof AdminConfiguracionParametrosRoute
  '/admin/ensuass/solicitudes': typeof AdminEnsuassSolicitudesRoute
  '/admin/notificaciones/envios': typeof AdminNotificacionesEnviosRoute
  '/admin/notificaciones/plantillas': typeof AdminNotificacionesPlantillasRoute
  '/admin/recet/costo-efectividad': typeof AdminRecetCostoEfectividadRoute
  '/admin/recet/importaciones': typeof AdminRecetImportacionesRoute
  '/admin/recet/referencias': typeof AdminRecetReferenciasRoute
  '/admin/recet/secciones': typeof AdminRecetSeccionesRoute
  '/admin/seguridad/aplicaciones': typeof AdminSeguridadAplicacionesRoute
  '/admin/seguridad/organizaciones': typeof AdminSeguridadOrganizacionesRoute
  '/admin/seguridad/permisos': typeof AdminSeguridadPermisosRoute
  '/admin/seguridad/roles': typeof AdminSeguridadRolesRoute
  '/admin/seguridad/sesiones': typeof AdminSeguridadSesionesRoute
  '/admin/seguridad/smtp': typeof AdminSeguridadSmtpRoute
  '/admin/seguridad/usuarios': typeof AdminSeguridadUsuariosRoute
  '/admin/onboarding/pasos/$id': typeof AdminOnboardingPasosIdRoute
  '/admin/recet/fichas/$id': typeof AdminRecetFichasIdRoute
  '/admin/recet/tecnologias/$id': typeof AdminRecetTecnologiasIdRoute
  '/admin/onboarding/pasos': typeof AdminOnboardingPasosIndexRoute
  '/admin/recet/fichas': typeof AdminRecetFichasIndexRoute
  '/admin/recet/tecnologias': typeof AdminRecetTecnologiasIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/_public/ensuass': typeof PublicEnsuassRoute
  '/_public/estadisticas': typeof PublicEstadisticasRoute
  '/_public/faq': typeof PublicFaqRoute
  '/_public/noticias': typeof PublicNoticiasRoute
  '/_public/quienes-somos': typeof PublicQuienesSomosRoute
  '/admin/inicio': typeof AdminInicioRoute
  '/_public/': typeof PublicIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/configuracion/parametros': typeof AdminConfiguracionParametrosRoute
  '/admin/ensuass/solicitudes': typeof AdminEnsuassSolicitudesRoute
  '/admin/notificaciones/envios': typeof AdminNotificacionesEnviosRoute
  '/admin/notificaciones/plantillas': typeof AdminNotificacionesPlantillasRoute
  '/admin/onboarding/pasos': typeof AdminOnboardingPasosRouteWithChildren
  '/admin/recet/costo-efectividad': typeof AdminRecetCostoEfectividadRoute
  '/admin/recet/importaciones': typeof AdminRecetImportacionesRoute
  '/admin/recet/referencias': typeof AdminRecetReferenciasRoute
  '/admin/recet/secciones': typeof AdminRecetSeccionesRoute
  '/admin/seguridad/aplicaciones': typeof AdminSeguridadAplicacionesRoute
  '/admin/seguridad/organizaciones': typeof AdminSeguridadOrganizacionesRoute
  '/admin/seguridad/permisos': typeof AdminSeguridadPermisosRoute
  '/admin/seguridad/roles': typeof AdminSeguridadRolesRoute
  '/admin/seguridad/sesiones': typeof AdminSeguridadSesionesRoute
  '/admin/seguridad/smtp': typeof AdminSeguridadSmtpRoute
  '/admin/seguridad/usuarios': typeof AdminSeguridadUsuariosRoute
  '/admin/onboarding/pasos/$id': typeof AdminOnboardingPasosIdRoute
  '/admin/recet/fichas/$id': typeof AdminRecetFichasIdRoute
  '/admin/recet/tecnologias/$id': typeof AdminRecetTecnologiasIdRoute
  '/admin/onboarding/pasos/': typeof AdminOnboardingPasosIndexRoute
  '/admin/recet/fichas/': typeof AdminRecetFichasIndexRoute
  '/admin/recet/tecnologias/': typeof AdminRecetTecnologiasIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/ensuass'
    | '/estadisticas'
    | '/faq'
    | '/noticias'
    | '/quienes-somos'
    | '/admin/inicio'
    | '/admin/'
    | '/admin/configuracion/parametros'
    | '/admin/ensuass/solicitudes'
    | '/admin/notificaciones/envios'
    | '/admin/notificaciones/plantillas'
    | '/admin/onboarding/pasos'
    | '/admin/recet/costo-efectividad'
    | '/admin/recet/importaciones'
    | '/admin/recet/referencias'
    | '/admin/recet/secciones'
    | '/admin/seguridad/aplicaciones'
    | '/admin/seguridad/organizaciones'
    | '/admin/seguridad/permisos'
    | '/admin/seguridad/roles'
    | '/admin/seguridad/sesiones'
    | '/admin/seguridad/smtp'
    | '/admin/seguridad/usuarios'
    | '/admin/onboarding/pasos/$id'
    | '/admin/recet/fichas/$id'
    | '/admin/recet/tecnologias/$id'
    | '/admin/onboarding/pasos/'
    | '/admin/recet/fichas/'
    | '/admin/recet/tecnologias/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/ensuass'
    | '/estadisticas'
    | '/faq'
    | '/noticias'
    | '/quienes-somos'
    | '/admin/inicio'
    | '/'
    | '/admin'
    | '/admin/configuracion/parametros'
    | '/admin/ensuass/solicitudes'
    | '/admin/notificaciones/envios'
    | '/admin/notificaciones/plantillas'
    | '/admin/recet/costo-efectividad'
    | '/admin/recet/importaciones'
    | '/admin/recet/referencias'
    | '/admin/recet/secciones'
    | '/admin/seguridad/aplicaciones'
    | '/admin/seguridad/organizaciones'
    | '/admin/seguridad/permisos'
    | '/admin/seguridad/roles'
    | '/admin/seguridad/sesiones'
    | '/admin/seguridad/smtp'
    | '/admin/seguridad/usuarios'
    | '/admin/onboarding/pasos/$id'
    | '/admin/recet/fichas/$id'
    | '/admin/recet/tecnologias/$id'
    | '/admin/onboarding/pasos'
    | '/admin/recet/fichas'
    | '/admin/recet/tecnologias'
  id:
    | '__root__'
    | '/_public'
    | '/admin'
    | '/login'
    | '/_public/ensuass'
    | '/_public/estadisticas'
    | '/_public/faq'
    | '/_public/noticias'
    | '/_public/quienes-somos'
    | '/admin/inicio'
    | '/_public/'
    | '/admin/'
    | '/admin/configuracion/parametros'
    | '/admin/ensuass/solicitudes'
    | '/admin/notificaciones/envios'
    | '/admin/notificaciones/plantillas'
    | '/admin/onboarding/pasos'
    | '/admin/recet/costo-efectividad'
    | '/admin/recet/importaciones'
    | '/admin/recet/referencias'
    | '/admin/recet/secciones'
    | '/admin/seguridad/aplicaciones'
    | '/admin/seguridad/organizaciones'
    | '/admin/seguridad/permisos'
    | '/admin/seguridad/roles'
    | '/admin/seguridad/sesiones'
    | '/admin/seguridad/smtp'
    | '/admin/seguridad/usuarios'
    | '/admin/onboarding/pasos/$id'
    | '/admin/recet/fichas/$id'
    | '/admin/recet/tecnologias/$id'
    | '/admin/onboarding/pasos/'
    | '/admin/recet/fichas/'
    | '/admin/recet/tecnologias/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRoute: typeof PublicRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/inicio': {
      id: '/admin/inicio'
      path: '/inicio'
      fullPath: '/admin/inicio'
      preLoaderRoute: typeof AdminInicioRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_public/quienes-somos': {
      id: '/_public/quienes-somos'
      path: '/quienes-somos'
      fullPath: '/quienes-somos'
      preLoaderRoute: typeof PublicQuienesSomosRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/noticias': {
      id: '/_public/noticias'
      path: '/noticias'
      fullPath: '/noticias'
      preLoaderRoute: typeof PublicNoticiasRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/faq': {
      id: '/_public/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof PublicFaqRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/estadisticas': {
      id: '/_public/estadisticas'
      path: '/estadisticas'
      fullPath: '/estadisticas'
      preLoaderRoute: typeof PublicEstadisticasRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/ensuass': {
      id: '/_public/ensuass'
      path: '/ensuass'
      fullPath: '/ensuass'
      preLoaderRoute: typeof PublicEnsuassRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/seguridad/usuarios': {
      id: '/admin/seguridad/usuarios'
      path: '/seguridad/usuarios'
      fullPath: '/admin/seguridad/usuarios'
      preLoaderRoute: typeof AdminSeguridadUsuariosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seguridad/smtp': {
      id: '/admin/seguridad/smtp'
      path: '/seguridad/smtp'
      fullPath: '/admin/seguridad/smtp'
      preLoaderRoute: typeof AdminSeguridadSmtpRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seguridad/sesiones': {
      id: '/admin/seguridad/sesiones'
      path: '/seguridad/sesiones'
      fullPath: '/admin/seguridad/sesiones'
      preLoaderRoute: typeof AdminSeguridadSesionesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seguridad/roles': {
      id: '/admin/seguridad/roles'
      path: '/seguridad/roles'
      fullPath: '/admin/seguridad/roles'
      preLoaderRoute: typeof AdminSeguridadRolesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seguridad/permisos': {
      id: '/admin/seguridad/permisos'
      path: '/seguridad/permisos'
      fullPath: '/admin/seguridad/permisos'
      preLoaderRoute: typeof AdminSeguridadPermisosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seguridad/organizaciones': {
      id: '/admin/seguridad/organizaciones'
      path: '/seguridad/organizaciones'
      fullPath: '/admin/seguridad/organizaciones'
      preLoaderRoute: typeof AdminSeguridadOrganizacionesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/seguridad/aplicaciones': {
      id: '/admin/seguridad/aplicaciones'
      path: '/seguridad/aplicaciones'
      fullPath: '/admin/seguridad/aplicaciones'
      preLoaderRoute: typeof AdminSeguridadAplicacionesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/recet/secciones': {
      id: '/admin/recet/secciones'
      path: '/recet/secciones'
      fullPath: '/admin/recet/secciones'
      preLoaderRoute: typeof AdminRecetSeccionesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/recet/referencias': {
      id: '/admin/recet/referencias'
      path: '/recet/referencias'
      fullPath: '/admin/recet/referencias'
      preLoaderRoute: typeof AdminRecetReferenciasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/recet/importaciones': {
      id: '/admin/recet/importaciones'
      path: '/recet/importaciones'
      fullPath: '/admin/recet/importaciones'
      preLoaderRoute: typeof AdminRecetImportacionesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/recet/costo-efectividad': {
      id: '/admin/recet/costo-efectividad'
      path: '/recet/costo-efectividad'
      fullPath: '/admin/recet/costo-efectividad'
      preLoaderRoute: typeof AdminRecetCostoEfectividadRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/onboarding/pasos': {
      id: '/admin/onboarding/pasos'
      path: '/onboarding/pasos'
      fullPath: '/admin/onboarding/pasos'
      preLoaderRoute: typeof AdminOnboardingPasosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/notificaciones/plantillas': {
      id: '/admin/notificaciones/plantillas'
      path: '/notificaciones/plantillas'
      fullPath: '/admin/notificaciones/plantillas'
      preLoaderRoute: typeof AdminNotificacionesPlantillasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/notificaciones/envios': {
      id: '/admin/notificaciones/envios'
      path: '/notificaciones/envios'
      fullPath: '/admin/notificaciones/envios'
      preLoaderRoute: typeof AdminNotificacionesEnviosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ensuass/solicitudes': {
      id: '/admin/ensuass/solicitudes'
      path: '/ensuass/solicitudes'
      fullPath: '/admin/ensuass/solicitudes'
      preLoaderRoute: typeof AdminEnsuassSolicitudesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/configuracion/parametros': {
      id: '/admin/configuracion/parametros'
      path: '/configuracion/parametros'
      fullPath: '/admin/configuracion/parametros'
      preLoaderRoute: typeof AdminConfiguracionParametrosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/recet/tecnologias/': {
      id: '/admin/recet/tecnologias/'
      path: '/recet/tecnologias'
      fullPath: '/admin/recet/tecnologias/'
      preLoaderRoute: typeof AdminRecetTecnologiasIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/recet/fichas/': {
      id: '/admin/recet/fichas/'
      path: '/recet/fichas'
      fullPath: '/admin/recet/fichas/'
      preLoaderRoute: typeof AdminRecetFichasIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/onboarding/pasos/': {
      id: '/admin/onboarding/pasos/'
      path: '/'
      fullPath: '/admin/onboarding/pasos/'
      preLoaderRoute: typeof AdminOnboardingPasosIndexRouteImport
      parentRoute: typeof AdminOnboardingPasosRoute
    }
    '/admin/recet/tecnologias/$id': {
      id: '/admin/recet/tecnologias/$id'
      path: '/recet/tecnologias/$id'
      fullPath: '/admin/recet/tecnologias/$id'
      preLoaderRoute: typeof AdminRecetTecnologiasIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/recet/fichas/$id': {
      id: '/admin/recet/fichas/$id'
      path: '/recet/fichas/$id'
      fullPath: '/admin/recet/fichas/$id'
      preLoaderRoute: typeof AdminRecetFichasIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/onboarding/pasos/$id': {
      id: '/admin/onboarding/pasos/$id'
      path: '/$id'
      fullPath: '/admin/onboarding/pasos/$id'
      preLoaderRoute: typeof AdminOnboardingPasosIdRouteImport
      parentRoute: typeof AdminOnboardingPasosRoute
    }
  }
}

interface PublicRouteChildren {
  PublicEnsuassRoute: typeof PublicEnsuassRoute
  PublicEstadisticasRoute: typeof PublicEstadisticasRoute
  PublicFaqRoute: typeof PublicFaqRoute
  PublicNoticiasRoute: typeof PublicNoticiasRoute
  PublicQuienesSomosRoute: typeof PublicQuienesSomosRoute
  PublicIndexRoute: typeof PublicIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicEnsuassRoute: PublicEnsuassRoute,
  PublicEstadisticasRoute: PublicEstadisticasRoute,
  PublicFaqRoute: PublicFaqRoute,
  PublicNoticiasRoute: PublicNoticiasRoute,
  PublicQuienesSomosRoute: PublicQuienesSomosRoute,
  PublicIndexRoute: PublicIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface AdminOnboardingPasosRouteChildren {
  AdminOnboardingPasosIdRoute: typeof AdminOnboardingPasosIdRoute
  AdminOnboardingPasosIndexRoute: typeof AdminOnboardingPasosIndexRoute
}

const AdminOnboardingPasosRouteChildren: AdminOnboardingPasosRouteChildren = {
  AdminOnboardingPasosIdRoute: AdminOnboardingPasosIdRoute,
  AdminOnboardingPasosIndexRoute: AdminOnboardingPasosIndexRoute,
}

const AdminOnboardingPasosRouteWithChildren =
  AdminOnboardingPasosRoute._addFileChildren(AdminOnboardingPasosRouteChildren)

interface AdminRouteChildren {
  AdminInicioRoute: typeof AdminInicioRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminConfiguracionParametrosRoute: typeof AdminConfiguracionParametrosRoute
  AdminEnsuassSolicitudesRoute: typeof AdminEnsuassSolicitudesRoute
  AdminNotificacionesEnviosRoute: typeof AdminNotificacionesEnviosRoute
  AdminNotificacionesPlantillasRoute: typeof AdminNotificacionesPlantillasRoute
  AdminOnboardingPasosRoute: typeof AdminOnboardingPasosRouteWithChildren
  AdminRecetCostoEfectividadRoute: typeof AdminRecetCostoEfectividadRoute
  AdminRecetImportacionesRoute: typeof AdminRecetImportacionesRoute
  AdminRecetReferenciasRoute: typeof AdminRecetReferenciasRoute
  AdminRecetSeccionesRoute: typeof AdminRecetSeccionesRoute
  AdminSeguridadAplicacionesRoute: typeof AdminSeguridadAplicacionesRoute
  AdminSeguridadOrganizacionesRoute: typeof AdminSeguridadOrganizacionesRoute
  AdminSeguridadPermisosRoute: typeof AdminSeguridadPermisosRoute
  AdminSeguridadRolesRoute: typeof AdminSeguridadRolesRoute
  AdminSeguridadSesionesRoute: typeof AdminSeguridadSesionesRoute
  AdminSeguridadSmtpRoute: typeof AdminSeguridadSmtpRoute
  AdminSeguridadUsuariosRoute: typeof AdminSeguridadUsuariosRoute
  AdminRecetFichasIdRoute: typeof AdminRecetFichasIdRoute
  AdminRecetTecnologiasIdRoute: typeof AdminRecetTecnologiasIdRoute
  AdminRecetFichasIndexRoute: typeof AdminRecetFichasIndexRoute
  AdminRecetTecnologiasIndexRoute: typeof AdminRecetTecnologiasIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminInicioRoute: AdminInicioRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminConfiguracionParametrosRoute: AdminConfiguracionParametrosRoute,
  AdminEnsuassSolicitudesRoute: AdminEnsuassSolicitudesRoute,
  AdminNotificacionesEnviosRoute: AdminNotificacionesEnviosRoute,
  AdminNotificacionesPlantillasRoute: AdminNotificacionesPlantillasRoute,
  AdminOnboardingPasosRoute: AdminOnboardingPasosRouteWithChildren,
  AdminRecetCostoEfectividadRoute: AdminRecetCostoEfectividadRoute,
  AdminRecetImportacionesRoute: AdminRecetImportacionesRoute,
  AdminRecetReferenciasRoute: AdminRecetReferenciasRoute,
  AdminRecetSeccionesRoute: AdminRecetSeccionesRoute,
  AdminSeguridadAplicacionesRoute: AdminSeguridadAplicacionesRoute,
  AdminSeguridadOrganizacionesRoute: AdminSeguridadOrganizacionesRoute,
  AdminSeguridadPermisosRoute: AdminSeguridadPermisosRoute,
  AdminSeguridadRolesRoute: AdminSeguridadRolesRoute,
  AdminSeguridadSesionesRoute: AdminSeguridadSesionesRoute,
  AdminSeguridadSmtpRoute: AdminSeguridadSmtpRoute,
  AdminSeguridadUsuariosRoute: AdminSeguridadUsuariosRoute,
  AdminRecetFichasIdRoute: AdminRecetFichasIdRoute,
  AdminRecetTecnologiasIdRoute: AdminRecetTecnologiasIdRoute,
  AdminRecetFichasIndexRoute: AdminRecetFichasIndexRoute,
  AdminRecetTecnologiasIndexRoute: AdminRecetTecnologiasIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
